// One-shot revalidation latch for account switches (app-update's
// shouldRevalidateForAppUpdate shape, but consumed on read): after the
// cookie re-mint the root loader must re-run once so the chrome refetches
// users.me — parents don't revalidate on child-level navigations by default.
let pending = false;

export const latchSessionRevalidation = () => {
    pending = true;
};

export const shouldRevalidateForSessionSwitch = (): boolean => {
    const wasPending = pending;
    pending = false;
    return wasPending;
};
